import React, { useState } from 'react'
import { Button } from 'evergreen-ui'
import { MdPayments } from 'react-icons/md'
import { AllowPay } from '../../../Components/AllowPermission'
import PaymentDialog from '../../../Components/PaymentDialog'


const StatusManageRegist_11 = ({ DataRegister }) => {
    const [ModalPay, setModalPay] = useState(false);
    return (
        <>
           
        </>
    )
}

export default StatusManageRegist_11